import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedTask } from "../linkers/types";

function removeTagFromEvent(httpClient: HttpClient) {
  return (tag: Tag, eventId: Id) =>
    httpClient
      .sendHttpRequest<LinkedTask>({
        endpoint: `/events/${eventId}`,
        method: HttpMethods.GET,
      })
      .then((event) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/events/${eventId}`,
          method: HttpMethods.PATCH,
          data: {
            // @ts-ignore
            tags: event.tags.filter((name) => name !== tag.name),
          },
        }),
      );
}

export { removeTagFromEvent };
